import { useCollectorStore, CollectorStateModel } from "./store";

export const useCollectorState = (): CollectorStateModel =>
  useCollectorStore();
